// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__rNxmB","topBottomGutter":"Layout_topBottomGutter__28FWZ"};